// tab页的状态
import {
  GETPAGELIST,
  REMOVETAB,
  FIXTAB,
  RESETPAGELIST
} from '../types'
export default {
  state: {
    pageList: []
  },
  getters: {},
  mutations: {
    [RESETPAGELIST]: function (state, data) {
      state.pageList = [{
        name: 'Home',
        meta: {
          title: '工作台',
          close: false
        }
      }]
      // if(data == 1) {
      //   state.pageList = [{
      //     name: 'home/index',
      //     meta: {
      //       title: '整体数据概况',
      //       close: false
      //     }
      //   }]
      // } else {
      //   state.pageList = [{
      //     name: 'enterpriseManagement/index',
      //     meta: {
      //       title: '单位信息查询',
      //       close: false
      //     }
      //   }]
      // }
    },
    [GETPAGELIST]: function (state, data) {
      let newdata = {}
      newdata.name = data.name
      newdata.meta = data.meta
      state.pageList.push(newdata)
      // localStorage.setItem(LOCAL_STORAGE_KEY_PAGELIST, JSON.stringify(state.pageList))
    },
    [REMOVETAB]: function (state, data) {
      state.pageList = data.tabs.filter(tab => tab.name !== data.targetName)
    },
    // 设置固定页面，刷新时不会丢失
    [FIXTAB]: function (state, data) {
      state.pageList[0] = {
        name: 'Home',
        meta: {
          title: '工作台',
          close: false
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/vuex/modules/tab.js